import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MatSnackBar,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatPaginator,
} from "@angular/material";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ClipBoardService } from "src/app/services/clipboard.service";
import { ServerService } from "src/app/services/server.service";
import { ActionItemsComponent } from "./action-items/action-items.component";
import { ClientParticipantComponent } from "./client-participant/client-participant.component";
@Component({
  selector: "app-review-master",
  templateUrl: "./review-master.component.html",
  styleUrls: ["./review-master.component.scss"],
})
export class ReviewMasterComponent implements OnInit {
  authToken: any = localStorage.getItem("token");
  userInfo: any = JSON.parse(localStorage.getItem("userInfo"));
  showComponentLoader: boolean = false;
  actionItemsComponent: MatDialogRef<ActionItemsComponent>;
  clientParticipantComponent:MatDialogRef<ClientParticipantComponent>

  project: any = {
    campaigns: [],
    pagination: {},
  };

  elasticSearch: any = "";
  statusSpinner: boolean = false;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  pageIndex: number = 0;
  pageSize: number = 100;

  lenCount: any = 0;

  url = "";

  createdAt: any;
  selectedClientName: any;
  selectedCampaignType: any;
  selectedStatus: any;
  selectedSalePerson: any;
  selectedAccountManager: any;
  selectedClientType: any;
  selectedProjectType: any;
  selectedAccountType: any;
  selectedSalesterritory: any;
  selectedDealType: any;

  allIsActive: boolean = true;

  campaignTypeList: any;
  campaignStatusList: any;
  campaignSalesCityList: any;
  mmList: any;
  clientList: any;
  salePersonList: any;
  selectedCampaign:any
  campaignList:any
  selectedCreatedBy:any
  createdByList:any;
  selectedMM:any;
  selectedReviewType:any;
  reviewType:any
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private titleService: Title,
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private snackBar: MatSnackBar
  ) {
    // sessionStorage.clear();
    this.showComponentLoader = true;
    this.titleService.setTitle("AutomateLeads - Review Master");
  }

  ngOnInit() {
    this.allReviewMaster();
    this.getCommon();
    // this.getClient();
    this.getSP();
    this.getMM();
    this.getCampaignForFilter();
    this.getCreatedBy();
  }

  drrList: any;
  allReviewMaster(isFilter?: any) {
    if (isFilter == "filter") {
      this.allIsActive = false;
    }

    let body = {};

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch;
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [
        this.createdAt.formatted.split(" - ")[0],
        this.createdAt.formatted.split(" - ")[1],
      ];
    }

    if (this.selectedClientName != undefined && this.selectedClientName != "") {
      body["client_id"] = this.selectedClientName;
    }

    if (
      this.selectedCampaignType != undefined &&
      this.selectedCampaignType != ""
    ) {
      body["campaign_type"] = this.selectedCampaignType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
    }

    if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
      body["sales_manager_id"] = this.selectedSalePerson;
    }

    if (
      this.selectedAccountManager != undefined &&
      this.selectedAccountManager != ""
    ) {
      body["account_manager_id"] = this.selectedAccountManager;
    }

    if (this.selectedClientType != undefined && this.selectedClientType != "") {
      body["client_type"] = this.selectedClientType;
    }

    if (
      this.selectedProjectType != undefined &&
      this.selectedProjectType != ""
    ) {
      body["project_type"] = this.selectedProjectType;
    }

    if (
      this.selectedAccountType != undefined &&
      this.selectedAccountType != ""
    ) {
      body["account_type"] = this.selectedAccountType;
    }

    if (
      this.selectedSalesterritory != undefined &&
      this.selectedSalesterritory != ""
    ) {
      body["sales_city"] = this.selectedSalesterritory;
    }

    if (this.selectedDealType != undefined && this.selectedDealType != "") {
      body["deal_type"] = this.selectedDealType;
    }
    if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
      body['campaign_id'] =  this.selectedCampaign
    }
    if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
      body['created_by_id'] =  this.selectedCreatedBy
    }
    if (this.selectedReviewType != undefined && this.selectedReviewType != "") {
      body['review_type'] =  this.selectedReviewType
    }
    
    // if ((this.selectedJobCategory != undefined || this.selectedJobCategory != null) && this.selectedJobCategory != "") {
    //   body["job_category"] = this.selectedJobCategory;
    // }

    //console.log(body)

    this.pageIndex = 0;
    this.pageSize = 50;

    this.showComponentLoader = true;

    this.url =
      "campaign_module/campaign_reviews/master?per_page=" +
      this.pageSize +
      "&page=" +
      this.pageIndex;

    this.serverService
      .campaignListByFilter(this.url, body, this.authToken)
      .subscribe(
        (data) => {
          this.project = data;
          console.log(this.project);
          //console.log(this.project)
          //this.lenCount = data.creative_jobs.length
          //console.log(this.lenCount)

          // this.drrList = this.project.campaigns.map(item => {
          //   if (item.mode_of_delivery != '' && item.mode_of_delivery != null && item.mode_of_delivery != undefined) {
          //     console.log(item.mode_of_delivery)
          //     if(item.mode_of_delivery!='' && item.mode_of_delivery!=null && item.mode_of_delivery!=undefined){
          //       return {...item.mode_of_delivery, mode_of_delivery: JSON.parse(item.mode_of_delivery)
          //       };
          //     }
          //   }
          //   });

          this.showComponentLoader = false;
        },
        (err) => {
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  getNext(event) {
    this.showComponentLoader = true;

    let body1 = {
      per_page: event.pageSize,
      page: event.pageIndex,
    };

    let body = {};

    this.pageSize = body1.per_page;
    this.pageIndex = body1.page;
    let indexPage = this.pageIndex + 1;

    if (this.elasticSearch.trim() != "") {
      body["query"] = this.elasticSearch;
    }

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [
        this.createdAt.formatted.split(" - ")[0],
        this.createdAt.formatted.split(" - ")[1],
      ];
    }

    if (
      this.selectedCampaignType != undefined &&
      this.selectedCampaignType != ""
    ) {
      body["campaign_type"] = this.selectedCampaignType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
    }

    if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
      body["sales_manager_id"] = this.selectedSalePerson;
    }

    if (
      this.selectedAccountManager != undefined &&
      this.selectedAccountManager != ""
    ) {
      body["account_manager_id"] = this.selectedAccountManager;
    }

    if (this.selectedClientType != undefined && this.selectedClientType != "") {
      body["client_type"] = this.selectedClientType;
    }

    if (
      this.selectedProjectType != undefined &&
      this.selectedProjectType != ""
    ) {
      body["project_type"] = this.selectedProjectType;
    }

    if (
      this.selectedAccountType != undefined &&
      this.selectedAccountType != ""
    ) {
      body["account_type"] = this.selectedAccountType;
    }

    if (
      this.selectedSalesterritory != undefined &&
      this.selectedSalesterritory != ""
    ) {
      body["sales_city"] = this.selectedSalesterritory;
    }

    if (this.selectedDealType != undefined && this.selectedDealType != "") {
      body["deal_type"] = this.selectedDealType;
    }
    if (this.selectedCampaign != undefined && this.selectedCampaign != "") {
      body['campaign_id'] =  this.selectedCampaign
    }
    if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
      body['created_by_id'] =  this.selectedCreatedBy
    }

    this.url =
      "campaign_module/campaign_reviews/master?per_page=" +
      this.pageSize +
      "&page=" +
      indexPage;

    this.serverService
      .campaignListByFilter(this.url, body, this.authToken)
      .subscribe(
        (data) => {
          this.project = data;
          this.showComponentLoader = false;
        },
        (err) => {
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  filter(campaignStatus?: any) {
    let body = {};

    if (this.createdAt != undefined && this.createdAt != "") {
      body["created_at"] = [
        this.createdAt.formatted.split(" - ")[0],
        this.createdAt.formatted.split(" - ")[1],
      ];
    }

    if (this.selectedClientName != undefined && this.selectedClientName != "") {
      body["client_name"] = this.selectedClientName;
    }

    if (
      this.selectedCampaignType != undefined &&
      this.selectedCampaignType != ""
    ) {
      body["campaign_type"] = this.selectedCampaignType;
    }

    if (this.selectedStatus != undefined && this.selectedStatus != "") {
      body["status"] = this.selectedStatus;
    }

    if (this.selectedSalePerson != undefined && this.selectedSalePerson != "") {
      body["sale_person"] = this.selectedSalePerson;
    }

    if (
      this.selectedAccountManager != undefined &&
      this.selectedAccountManager != ""
    ) {
      body["account_manager"] = this.selectedAccountManager;
    }

    if (this.selectedClientType != undefined && this.selectedClientType != "") {
      body["client_type"] = this.selectedClientType;
    }

    if (
      this.selectedProjectType != undefined &&
      this.selectedProjectType != ""
    ) {
      body["project_type"] = this.selectedProjectType;
    }

    if (
      this.selectedAccountType != undefined &&
      this.selectedAccountType != ""
    ) {
      body["account_type"] = this.selectedAccountType;
    }

    if (
      this.selectedSalesterritory != undefined &&
      this.selectedSalesterritory != ""
    ) {
      body["sales_territory"] = this.selectedSalesterritory;
    }

    if (this.selectedDealType != undefined && this.selectedDealType != "") {
      body["deal_type"] = this.selectedDealType;
    }
    if (this.selectedCreatedBy != undefined && this.selectedCreatedBy != "") {
      body["created_by_id"] = this.selectedCreatedBy;
    }
    if (this.selectedMM != undefined && this.selectedMM != "") {
      body["marketing_manager_id"] = this.selectedMM;
    }

    //console.log(body)

  }

 

  getSP() {
    this.showComponentLoader = true;

    let url = "/campaign_module/user_list?user_type=SalesAdmin";
    this.serverService.getSalePerson(url, this.authToken).subscribe(
      (data) => {
        this.salePersonList = data.data;
        this.salePersonList.unshift({ id: null, name: "Sales Person" });
        //console.log(this.salePersonList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }

  getMM() {
    this.showComponentLoader = true;

    let url = "/campaign_module/get_marketing_user";
    this.serverService.getSalePerson(url, this.authToken).subscribe(
      (data) => {
        this.mmList = data.data;
        this.mmList.unshift({ id: null, name: "Marketing Manager" });
        //console.log(this.mmList)
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }

  getCommon() {
    this.showComponentLoader = true;

    let url = "campaign_module/get_common_details";

    this.serverService.getEscalationCategory(url, this.authToken).subscribe(
      (data) => {
        console.log(data)
        this.reviewType = data.campaign_review_review_type
        this.campaignTypeList = data.creative_campaign_type_list;
        this.campaignStatusList = data.campaign_status;
        this.campaignSalesCityList = data.campaign_sales_city_list;
        this.showComponentLoader = false;
      },
      (err) => {
        this.showComponentLoader = false;
        this.clipBoardService.checkServerError(err, this.authToken);
      }
    );
  }

  removeSearch() {
    this.elasticSearch = "";
    this.allReviewMaster();
  }

  updateCampaignStatus(data: any, status) {
    let body = {
      status: status,
      // 'delivery_manager_id': this.project.spAm,
      // 'marketing_manager_id': this.project.spAm,
      // 'client_type': this.project.clientType,
      // 'client_name': this.project.clientName,
      // 'client_number': this.project.clientEmail,
      // 'city': this.project.city,
      // 'client_rera': this.project.clientRera,
      // 'project_name': this.project.projectName,
      // 'project_type': this.project.projectType,
      // 'project_address': this.project.location,
      // 'latitude': this.project.latitude,
      // 'longitude': this.project.longitude,
      // 'min_price': this.project.price,
      // 'project_configuration': this.project.configuration,
      // 'project_status': this.project.projectStatus,
      // 'possession': this.project.possession,
      // 'rera_number': this.project.reraId,
      // 'campaign_type': this.project.campaignType,
      // 'duration': this.project.duration,
      // 'no_of_leads': this.project.noOfLeads,
      // 'mode_of_delivery': this.project,
      // 'mode_of_notification': this.project,
      // 'offers': this.project,
      // 'media_plan': this.project,
    };

    this.showComponentLoader = true;
    this.serverService
      .editSaleCampaign(data.id, body, this.authToken)
      .subscribe(
        (data) => {
          // console.log(data);
          this.showComponentLoader = false;
          this.clipBoardService.showMessgeInText(
            "Campaign Update Successfully",
            "success-snackbar"
          );
          this.allReviewMaster();
        },
        (err) => {
          this.showComponentLoader = false;
          this.clipBoardService.checkServerError(err, this.authToken);
        }
      );
  }

  goToDetail(data: any) {
    // this.router.navigate([,'_blank'])
    this.router.navigate([]).then((result) => {
      window.open("page/campaign-details/" + data.id, "_blank");
    });
  }

  getStyle(status: string) {
    switch (status) {
      case "Todo":
        return { "background-color": "#E3E3E3", color: "#454545" };
      case "In progress":
        return { "background-color": "#E3E3E3", color: "#454545" };
      case "Awaiting Update":
        return { "background-color": "#D0E0FF", color: "#102348" };
      case "On Hold":
        return { "background-color": "#E3E3E3", color: "#454545" };
      case "Done":
        return {
          "background-color": "rgba(87, 211, 87, 0.23)",
          color: "#008000",
        };
      case "Cancelled":
        return {
          "background-color": "rgba(255, 247, 246, 1)",
          color: "#8b2a1d",
          border: "1px solid #ab7d7d",
        };
      default:
        return { "background-color": "#E3E3E3", color: "#454545" };
    }
  }



  selectCreatedDate(event: any) {
    if (
      event.formatted != undefined &&
      event.formatted != "" &&
      event.formatted != null
    ) {
      this.createdAt = event;
      this.allReviewMaster("filter");
    } else {
      this.createdAt = undefined;
      this.allReviewMaster("filter");
    }
  }

  resetFilter() {
    this.createdAt = null;
    this.selectedClientName = null;
    this.selectedCampaignType = null;
    this.selectedStatus = null;
    this.selectedSalePerson = null;
    this.selectedAccountManager = null;
    this.selectedClientType = null;
    this.selectedProjectType = null;
    this.selectedAccountType = null;
    this.selectedSalesterritory = null;
    this.selectedDealType = null;
    this.selectedCreatedBy = null;
    this.selectedMM = null;
    this.selectedCampaign = null;
    this.selectedReviewType = null
   
    this.allReviewMaster();
    this.allIsActive = true;
  }
  navToCampaign(item: any) {
    this.router.navigate([]).then((result) => {
      window.open("page/campaign-details/" + item.campaign_id, "_blank");
    });
  }

  openActionItem(item: any) {
    if(item.action_item_count != 0)
 {
    this.actionItemsComponent = this.dialog.open(ActionItemsComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,

      width: "35vw",
      panelClass: "cdk-overlay-panel-right-side",

      data: item,
    });
  }
  }
  openCampaignClient(item: any) {
    if(item.client_participants.length != 0)
 {
    this.clientParticipantComponent = this.dialog.open(ClientParticipantComponent, {
      hasBackdrop: true,
      disableClose: false,
      autoFocus: true,

      width: "35vw",
      panelClass: "cdk-overlay-panel-right-side",

      data: item,
    });
  }
  }
  getPart(item:any){
    return item.participants_user.map(participant => participant.name).join(", ");
  }
  formatToTwoDecimalPlaces(value: any): string {
    const num = parseFloat(value);
  
  // Check if the parsed value is a valid number
  if (isNaN(num)) {
    throw new TypeError("Input is not a valid number");
  }
  
  return num.toFixed(2);
  }
  getCampaignForFilter() {

    this.showComponentLoader = true;

    this.serverService.getCampaignForFilter("campaign_module/campaign/list", this.authToken).subscribe(
      data => {
        this.campaignList = data;
        this.campaignList.unshift({id:null, name:'Campaign'})
        this.showComponentLoader = false
      },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }
  getCreatedBy() {

    this.showComponentLoader = true

    let url = "/campaign_module/user_list";
    this.serverService.getSalePerson(url, this.authToken).subscribe(data => {
      this.createdByList = data.data
      this.createdByList.unshift({id:null, name:'Created By'})
      //console.log(this.salePersonList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }
}
